/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ig-search-wrap{position:relative}.ig-search-wrap mat-spinner{position:absolute;top:9px;right:8px}.ig-search-wrap ig-field{margin-bottom:0}.ig-search-wrap .search-result{position:absolute;z-index:999;background-color:#fff;margin-top:8px;max-height:400px;overflow-y:auto}.ig-search-wrap .search-result div{padding:8px;vertical-align:middle;border-bottom:1px dashed #add8e6}.ig-search-wrap .search-result div div{display:inline-block;width:8px;height:8px;color:#000;margin-right:8px;border-radius:12px;line-height:8px;background-color:#eec30d}.ig-search-wrap .search-result div[item]{cursor:pointer}.ig-search-wrap .search-result div[item]:hover{background-color:#d2f2fc}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/search/search.component.scss.ngstyle.js.pre-build-optimizer.js